<section
  class="report-loader"
  [class.dark]="isDark()"
  [class.show-loader]="loader"
  [class.tablet]="isMobile()"
  (click)="emitClick.emit()">
  <div class="report-loader__container">
    <div class="loader"></div>
  </div>
</section>
